import config from 'config';

export function getMensProductCategories() {
  return [
    config.get('public.productCategories.mens'),
    config.get('public.productCategories.scrubsMensBottom'),
    config.get('public.productCategories.scrubsMensTop'),
    config.get('public.productCategories.scrubsMensJacket'),
    config.get('public.productCategories.scrubsMensUnderscrubs'),
  ];
}

export function getMensBottomsProductCategories() {
  return [
    config.get('public.productCategories.mensBottom'),
    config.get('public.productCategories.scrubsMensBottom'),
  ];
}

export function getMensTopsProductCategories() {
  return [
    config.get('public.productCategories.mensTop'),
    config.get('public.productCategories.scrubsMensTop'),
    config.get('public.productCategories.scrubsMensJacket'),
    config.get('public.productCategories.scrubsMensUnderscrubs'),
  ];
}

export function getWomensProductCategories() {
  return [
    config.get('public.productCategories.mens'),
    config.get('public.productCategories.scrubsWomensBottom'),
    config.get('public.productCategories.scrubsWomensTop'),
    config.get('public.productCategories.scrubsWomensJacket'),
    config.get('public.productCategories.scrubsWomensUnderscrubs'),
  ];
}

export function getWomensBottomsProductCategories() {
  return [
    config.get('public.productCategories.womensBottom'),
    config.get('public.productCategories.scrubsWomensBottom'),
  ];
}

export function getWomensTopsProductCategories() {
  return [
    config.get('public.productCategories.womensTop'),
    config.get('public.productCategories.scrubsWomensTop'),
    config.get('public.productCategories.scrubsWomensJacket'),
    config.get('public.productCategories.scrubsWomensUnderscrubs'),
  ];
}

export function getKidsProductCategories() {
  return [
    config.get('public.productCategories.kidsApparel'),
    config.get('public.productCategories.boysApparel'),
    config.get('public.productCategories.girlsApparel'),
  ];
}
